customElements.component = "embroidery-section";
customElements.component_button = "embroidery-button";

const EMBROIDERY_LINE_PROPERTY = Object.freeze({
  text: 'Text',
  font: 'Font',
  threadColor: 'Thread Color',
  estimatedShipBy: 'Est. Ship By',
});

const EMBROIDERY_CART_EDIT_QUERY = Object.freeze({
  flag: 'edit_embroidery',
  line: 'line',
  flagValue: '1',
});

function getShopifyRoutesRoot() {
  return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
}

function getCartChangeJsUrl() {
  return typeof theme !== 'undefined' && theme.routes && theme.routes.cart_change_url
    ? theme.routes.cart_change_url
    : '/cart/change.js';
}

function getCartAddJsUrl() {
  return typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url
    ? theme.routes.cart_add_url
    : `${getShopifyRoutesRoot()}cart/add.js`;
}

function getEmbroideryThemeString(themeStringKey) {
  if (typeof theme !== 'undefined' && theme.strings && typeof theme.strings[themeStringKey] === 'string') {
    return theme.strings[themeStringKey];
  }
  return '';
}

if (!customElements.get(customElements.component)) {
  class EmbroiderySection extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        tooltipHandler: '.js-toggle-tooltip',
        dropdownInfoHandler: '.js-toggle-dropdown-info',
        colorHandler: '.js-toggle-color',
        fontHandler: '.js-toggle-font',
        inputHandler: '.js-handle-input-change',
        popupInfoHandler: '.js-toggle-popup-info',
        addToCartHandler: '.js-add-to-cart-handler',
        removeCheckboxErrorHandler: '.js-remove-checkbox-error-handler',
        accordionHandler: '.js-toggle-accordion',

        threadColorSwatch: '.embroidery__thread-color-swatch',
        inputWrapper: '.embroidery__input-wrapper',
        input: '.embroidery__input-wrapper input',
        inputCharacterLimitMax: '.embroidery__input-character-limit-max',
        inputCharacterLimitCurrent: '.embroidery__input-character-limit-current',
        validationMessageText: '.embroidery__validation-message--text',
        validationMessageInappropriateLanguage: '.embroidery__validation-message--inappropriate-language',
        validationMessageTextRequired: '.embroidery__validation-message--text-required',
        validationMessageConfirmationCheckbox: '.embroidery__validation-message--confirmation-checkbox',
        settingsButtonPrice: '.embroidery__settings-button-price',
        settingsButtonDescription: '.embroidery__product-color-description',
        settingsImage: '.embroidery__image-wrapper img',
        imageInner: '.embroidery__image-inner',
        embroideryCloseButton: '.embroidery__close-button',
        canvas: '.embroidery__canvas',
        canvasText: '.embroidery__canvas-text',
        colorIcon: '.embroidery__product-color-icon',
        accordion: '.cc-accordion',

        activeClass: 'active-item',
        disabledClass: 'disabled',
        pendingClass: 'embroidery__settings-button--pending',
        overflowHiddenClass: 'overflow-hidden',
        addToCartLabelSpan: 'span:not(.embroidery__settings-button-price)',
      }

      this.tooltipHandler = this.querySelector(this.selectors.tooltipHandler);
      this.dropdownInfoHandlers = this.querySelectorAll(this.selectors.dropdownInfoHandler);
      this.colorHandlers = this.querySelectorAll(this.selectors.colorHandler);
      this.fontHandlers = this.querySelectorAll(this.selectors.fontHandler);
      this.inputHandler = this.querySelector(this.selectors.inputHandler);
      this.popupInfoHandlers = this.querySelectorAll(this.selectors.popupInfoHandler);
      this.addToCartHandler = this.querySelector(this.selectors.addToCartHandler);
      this.removeCheckboxErrorHandler = this.querySelector(this.selectors.removeCheckboxErrorHandler);
      this.accordionHandlers = this.querySelectorAll(this.selectors.accordionHandler);

      this.colorIcon = this.querySelector(this.selectors.colorIcon);
      this.threadColorSwatch = this.querySelector(this.selectors.threadColorSwatch);
      this.inputWrapper = this.querySelector(this.selectors.inputWrapper);
      this.input = this.querySelector(this.selectors.input);
      this.inputCharacterLimitMax = this.querySelector(this.selectors.inputCharacterLimitMax);
      this.inputCharacterLimitCurrent = this.querySelector(this.selectors.inputCharacterLimitCurrent);
      this.validationMessageText = this.querySelector(this.selectors.validationMessageText);
      this.validationMessageInappropriateLanguage = this.querySelector(this.selectors.validationMessageInappropriateLanguage);
      this.validationMessageTextRequired = this.querySelector(this.selectors.validationMessageTextRequired);
      this.validationMessageConfirmationCheckbox = this.querySelector(this.selectors.validationMessageConfirmationCheckbox);
      this.embroideryCloseButton = this.querySelector(this.selectors.embroideryCloseButton);
      this.canvas = this.querySelector(this.selectors.canvas);
      this.canvasText = this.querySelector(this.selectors.canvasText);
      this.accordions = this.querySelectorAll(this.selectors.accordion);

      this.shipDateEl = this.querySelector('.embroidery__ship-date');
      this.updateShipDate();

      this.handleEmbroideryCloseDuringCartEdit = this.handleEmbroideryCloseDuringCartEdit.bind(this);
    }

    stripEmbroideryCartEditQuery() {
      const cartEditQueryParams = EMBROIDERY_CART_EDIT_QUERY;
      const urlSearchParams = new URLSearchParams(window.location.search);
      
      if (!urlSearchParams.has(cartEditQueryParams.flag)) return;
      urlSearchParams.delete(cartEditQueryParams.flag);
      urlSearchParams.delete(cartEditQueryParams.line);
     
      const queryString = urlSearchParams.toString();
      const pathnameSearchAndHash = `${window.location.pathname}${queryString ? `?${queryString}` : ''}${window.location.hash}`;
      
      window.history.replaceState({}, '', pathnameSearchAndHash);
    }

    readLineItemProperty(lineItem, propertyName) {
      const lineItemProperties = lineItem.properties;
      
      if (lineItemProperties == null) return '';
      
      if (typeof lineItemProperties === 'object' && !Array.isArray(lineItemProperties)) {
        return String(lineItemProperties[propertyName] ?? '');
      }
      
      if (Array.isArray(lineItemProperties)) {
        for (let entryIndex = 0; entryIndex < lineItemProperties.length; entryIndex += 1) {
          const propertyEntry = lineItemProperties[entryIndex];
          if (propertyEntry && (propertyEntry.name === propertyName || propertyEntry.first === propertyName)) {
            return String(propertyEntry.value ?? propertyEntry.last ?? '');
          }
        }
      }
      return '';
    }

    findSwatchForVariant(variantId) {
      const variantIdAsString = String(variantId);
      
      return [...document.querySelectorAll('[data-embroidery-product-id]')].find(
        (element) => element.dataset.embroideryProductId === variantIdAsString
      );
    }

    findFontBlockByTitle(title) {
      if (!title) return null;
      
      return [...this.querySelectorAll('[data-font]')].find((element) => element.dataset.title === title);
    }

    findThreadColorByTitle(title) {
      if (!title) return null;
      
      return [...this.querySelectorAll('[data-thread-color]')].find((element) => element.dataset.title === title);
    }

    openEmbroideryVisualizer() {
      const mainSection = document.querySelector('.embroidery');
      const body = document.body;
      
      if (mainSection && !mainSection.classList.contains('active-item')) {
        mainSection.classList.add('active-item');
        body.classList.add('overflow-hidden');
      }
    }

    getAddToCartLabelSpan() {
      return this.addToCartHandler?.querySelector(this.selectors.addToCartLabelSpan);
    }

    resetEmbroideryCartEdit() {
      delete this.dataset.editCartLineKey;
      delete this._editModeQuantity;
      delete this._editOriginalVariantId;
      const labelSpan = this.getAddToCartLabelSpan();
      
      if (labelSpan && typeof this._defaultAddToCartLabel === 'string') {
        labelSpan.textContent = this._defaultAddToCartLabel;
      }
      
      delete this._defaultAddToCartLabel;
    }

    resetVisualizerFields() {
      if (this.input) {
        this.input.value = '';
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
      }

      if (this.removeCheckboxErrorHandler) {
        this.removeCheckboxErrorHandler.checked = false;
      }

      this.validationMessageText?.classList.remove(this.selectors.activeClass);
      this.validationMessageInappropriateLanguage?.classList.remove(this.selectors.activeClass);
      this.validationMessageTextRequired?.classList.remove(this.selectors.activeClass);
      this.validationMessageConfirmationCheckbox?.classList.remove(this.selectors.activeClass);

      const firstFontBlock = this.querySelector('[data-font]');
      if (firstFontBlock && !firstFontBlock.classList.contains(this.selectors.activeClass)) {
        firstFontBlock.click();
      }

      const firstThreadColor = this.querySelector('[data-thread-color]');
      if (firstThreadColor && !firstThreadColor.classList.contains(this.selectors.activeClass)) {
        firstThreadColor.click();
      }
    }

    handleEmbroideryCloseDuringCartEdit() {
      window.setTimeout(() => {
        if (!this.dataset.editCartLineKey) return;
        const overlay = document.querySelector('.embroidery');
        
        if (overlay && !overlay.classList.contains('active-item')) {
          this.resetEmbroideryCartEdit();
        }
      }, 0);
    }

    async applyEmbroideryCartEditFromQuery() {
      const cartEditQueryParams = EMBROIDERY_CART_EDIT_QUERY;
      const urlSearchParams = new URLSearchParams(window.location.search);
      
      if (urlSearchParams.get(cartEditQueryParams.flag) !== cartEditQueryParams.flagValue) return;

      const cartLineKey = urlSearchParams.get(cartEditQueryParams.line);
      
      if (!cartLineKey) return;

      const linePropertyKeys = EMBROIDERY_LINE_PROPERTY;
      const cartResponse = await fetch(`${getShopifyRoutesRoot()}cart.js`);
      
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json().catch(() => null);
      
      if (!cart || !Array.isArray(cart.items)) return;

      const lineItem = cart.items.find((item) => item.key === cartLineKey);
      
      if (!lineItem) {
        this.stripEmbroideryCartEditQuery();
        return;
      }

      const lineItemEmbroideryText = this.readLineItemProperty(lineItem, linePropertyKeys.text);
      
      if (!lineItemEmbroideryText) return;

      const labelSpan = this.getAddToCartLabelSpan();
      this._defaultAddToCartLabel = labelSpan?.textContent?.trim() ?? '';

      const swatchElement = this.findSwatchForVariant(lineItem.variant_id);
      if (!swatchElement) return;

      swatchElement.click();

      const fontBlockElement = this.findFontBlockByTitle(this.readLineItemProperty(lineItem, linePropertyKeys.font));
      fontBlockElement?.click();

      const threadColorElement = this.findThreadColorByTitle(this.readLineItemProperty(lineItem, linePropertyKeys.threadColor));
      threadColorElement?.click();

      if (this.input) {
        this.input.value = lineItemEmbroideryText;
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
      }

      if (this.removeCheckboxErrorHandler) {
        this.removeCheckboxErrorHandler.checked = false;
      }

      this.validationMessageConfirmationCheckbox?.classList.remove(this.selectors.activeClass);
      this.dataset.editCartLineKey = cartLineKey;
      this._editModeQuantity = lineItem.quantity;
      this._editOriginalVariantId = lineItem.variant_id;

      const updateLabel = this.dataset.labelUpdateCart;
      if (labelSpan && updateLabel) {
        labelSpan.textContent = updateLabel;
      }

      this.syncAddToCartEnabledState();
      this.stripEmbroideryCartEditQuery();
      this.openEmbroideryVisualizer();
    }

    /**
     * Variant unavailable uses `.disabled` (hidden button) + native disabled.
     * When the variant is available but text is invalid/empty, the button stays clickable
     * (no native disabled) so we can show validation on click; styling uses `--pending`.
     */
    syncAddToCartEnabledState() {
      const btn = this.addToCartHandler;
      if (!btn) return;

      if (btn.classList.contains(this.selectors.disabledClass)) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.remove(this.selectors.pendingClass);
        return;
      }

      const raw = this.input?.value ?? '';
      const text = raw.trim();
      const profane =
        text.length > 0 && window.LeoProfanity && window.LeoProfanity.check(raw);
      const textReady = text.length > 0 && !profane;

      if (!textReady) {
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add(this.selectors.pendingClass);
        return;
      }

      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove(this.selectors.pendingClass);
    }

    openEmbroideryTextAccordion() {
      if (!this.input) return;

      const details = this.input.closest('details');
      if (details && !details.open) {
        details.querySelector('summary')?.click();
      }

      requestAnimationFrame(() => {
        this.input.focus({ preventScroll: false });
        this.input.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    calculateShipDate(preorderDate, backorderDate, processingTime) {
      if (!processingTime) return '';

      const days = parseInt(processingTime, 10);
      if (isNaN(days)) return '';

      let baseDate;

      if (preorderDate) {
        baseDate = new Date(preorderDate + 'T00:00:00');
      } else if (backorderDate) {
        baseDate = new Date(backorderDate + 'T00:00:00');
      } else {
        baseDate = new Date();
      }

      baseDate.setDate(baseDate.getDate() + days);

      const monthTwoDigits = String(baseDate.getMonth() + 1).padStart(2, '0');
      const dayTwoDigits = String(baseDate.getDate()).padStart(2, '0');
      const yearTwoDigits = String(baseDate.getFullYear()).slice(-2);

      return `${monthTwoDigits}/${dayTwoDigits}/${yearTwoDigits}`;
    }

    updateShipDate() {
      const preorderDate = this.dataset.preorderDate || '';
      const backorderDate = this.dataset.backorderDate || '';
      const processingTime = this.dataset.processingTime || '';
      const productTitle = this.dataset.productTitle || '';
      const variantTitle = this.dataset.variantTitle || '';
      const shipDate = this.calculateShipDate(preorderDate, backorderDate, processingTime);

      if (shipDate && this.shipDateEl) {
        this.shipDateEl.innerHTML = `${productTitle} ${variantTitle} is estimated to <strong>ship by ${shipDate}</strong>`;
      } else if (this.shipDateEl) {
        this.shipDateEl.innerHTML = '';
      }
    }

    normalizeEszett(value, max = null) {
      if (max == null) {
        return { value: value.replace(/\u00DF/gi, 'ss'), trimmed: false };
      }

      let result = '';
      let trimmed = false;

      for (const char of value) {
        const chunk = /\u00DF/i.test(char) ? 'ss' : char;
        for (const nextChar of chunk) {
          if (result.length >= max) {
            trimmed = true;
            return { value: result, trimmed };
          }
          result += nextChar;
        }
      }

      return { value: result, trimmed };
    }

    getMaxCharacters() {
      const max = parseInt(this.input?.maxLength, 10);
      return Number.isFinite(max) && max > 0 ? max : null;
    }

    enforceCharacterLimit(value) {
      const max = this.getMaxCharacters();
      if (!max || value.length <= max) {
        return { value, trimmed: false };
      }
      return { value: value.slice(0, max), trimmed: true };
    }

    enforceSentenceCase(value) {
      const lower = value.toLowerCase();
      return lower.replace(/(^|[\s-])(\p{L})/gu, (m, sep, letter) => `${sep}${letter.toUpperCase()}`);
    }

    isSentenceCaseActive() {
      const activeFont = this.querySelector('[data-font].active-item');
      return activeFont?.dataset.sentencecase === 'true';
    }

    handleInputChange(event) {
      const target = event.currentTarget;
      const raw = target.value;
      const filtered = raw.replace(/[^\p{L}\s'’-]/gu, '');
      const maxChars = this.getMaxCharacters();
      const normalizedResult = this.normalizeEszett(filtered, maxChars);
      const normalized = normalizedResult.value;

      if (filtered !== raw) {
        const caret = target.selectionStart;
        target.value = normalized;
        target.setSelectionRange?.(caret, caret);
        this.validationMessageText.classList.add(this.selectors.activeClass);
        this.validationMessageTextRequired?.classList.remove(this.selectors.activeClass);
        this.syncAddToCartEnabledState();

        return null;
      }

      let wasTrimmedForLimit = normalizedResult.trimmed;

      if (normalized !== raw) {
        const caret = target.selectionStart;
        const eszettCount = (raw.match(/\u00DF/gi) || []).length;
        target.value = normalized;
        target.setSelectionRange?.(caret + eszettCount, caret + eszettCount);
      }

      if (this.isSentenceCaseActive()) {
        const enforced = this.enforceSentenceCase(target.value);
        
        if (enforced !== target.value) {
          const caret = target.selectionStart;
          
          target.value = enforced;
          target.setSelectionRange?.(caret, caret);
        }
      }

      const limitResult = this.enforceCharacterLimit(target.value);
      if (limitResult.trimmed) {
        target.value = limitResult.value;
        wasTrimmedForLimit = true;
        const caret = Math.min(target.selectionStart ?? target.value.length, target.value.length);
        target.setSelectionRange?.(caret, caret);
      }

      if (wasTrimmedForLimit) {
        this.flashTrimmedFeedback();
      }

      if (window.LeoProfanity.check(target.value)) {
        this.validationMessageInappropriateLanguage.classList.add(this.selectors.activeClass);
        this.validationMessageTextRequired?.classList.remove(this.selectors.activeClass);
        this.syncAddToCartEnabledState();

        return null;
      }

      if (!target.value.length) {
        this.inputCharacterLimitCurrent.innerText = '0';
        this.canvasText.innerText = '';
        this.validationMessageTextRequired?.classList.remove(this.selectors.activeClass);
        this.syncAddToCartEnabledState();

        return null;
      }

      this.validationMessageText?.classList.remove(this.selectors.activeClass);
      this.validationMessageInappropriateLanguage?.classList.remove(this.selectors.activeClass);
      this.validationMessageTextRequired?.classList.remove(this.selectors.activeClass);
      this.inputCharacterLimitCurrent.innerText = target.value.length;
      this.canvasText.innerText = target.value;

      this.syncAddToCartEnabledState();
    }

    toggleTooltip() {
      this.tooltipHandler?.classList.toggle(this.selectors.activeClass);
    }

    closeTooltip(event) {
      if (!this.tooltipHandler?.classList.contains(this.selectors.activeClass)) return;
      if (event.target.closest('.js-toggle-tooltip')) return;
      if (event.target.closest('.embroidery__tooltip-text')) return;

      this.tooltipHandler.classList.remove(this.selectors.activeClass);
    }

    toggleDropdownInfo(event) {
      const target = event.currentTarget;
      const currentDropdownInfo = target.closest('.cc-accordion-item');
      const dropdownInfoText = currentDropdownInfo.querySelector('.embroidery__product-color-name');
      const activeItem = currentDropdownInfo.querySelector(`.${this.selectors.activeClass}`);

      if (target.classList.contains(this.selectors.activeClass)) return null;

      dropdownInfoText.innerText = `(${target.dataset.title})`;
      activeItem?.classList.remove(this.selectors.activeClass);
      target.classList.add(this.selectors.activeClass);
    }

    toggleColor(event) {
      const target = event.currentTarget;

      this.threadColorSwatch.style.backgroundColor = target.dataset.color;
      this.canvasText.style.color = target.dataset.color;
    }

    toggleFont(event) {
      const target = event.currentTarget;
      const max = parseInt(target.dataset.maxCharacters, 10);

      this.canvas.dataset.title = target.dataset.title;
      this.inputWrapper.dataset.title = target.dataset.title;
      this.input.maxLength = max;
      this.inputCharacterLimitMax.innerText = max;

      const wasTrimmed = this.input.value.length > max;
      if (wasTrimmed) {
        this.input.value = this.input.value.slice(0, max);
      }

      if (target.dataset.sentencecase === 'true' && this.input.value) {
        this.input.value = this.enforceSentenceCase(this.input.value);
      }

      this.inputCharacterLimitCurrent.innerText = this.input.value.length;
      this.canvasText.innerText = this.input.value;

      if (wasTrimmed) this.flashTrimmedFeedback();

      this.syncAddToCartEnabledState();
    }

    flashTrimmedFeedback() {
      const wrapper = this.inputWrapper;
      const limit = this.querySelector('.embroidery__input-character-limit');
      if (!wrapper) return;

      this.openEmbroideryTextAccordion();

      requestAnimationFrame(() => {
        wrapper.classList.remove('embroidery__input-wrapper--trimmed');
        void wrapper.offsetWidth;
        wrapper.classList.add('embroidery__input-wrapper--trimmed');
        if (limit) {
          limit.classList.remove('embroidery__input-character-limit--flash');
          void limit.offsetWidth;
          limit.classList.add('embroidery__input-character-limit--flash');
        }
      });

      clearTimeout(this._trimmedTimer);
      this._trimmedTimer = setTimeout(() => {
        wrapper.classList.remove('embroidery__input-wrapper--trimmed');
        limit?.classList.remove('embroidery__input-character-limit--flash');
      }, 3500);
    }

    togglePopupInfo(event) {
      const target = event.currentTarget;
      const image = this.querySelector(this.selectors.settingsImage);
      const shortDescription = this.querySelector(this.selectors.settingsButtonDescription);
      const price = this.querySelector(this.selectors.settingsButtonPrice);
      const { embroideryImageUrl, embroideryPrice, productShortDescription, embroideryAvailable, embroideryProductId, embroideryFinalSale, preorderDate, backorderDate, processingTime, productTitle, variantTitle } = target.dataset;

      image.src = embroideryImageUrl;
      image.setAttribute('srcset', embroideryImageUrl);
      this.applyImageAspectRatio(image);
      price.innerText = embroideryPrice;
      shortDescription.innerHTML = productShortDescription;

      if (embroideryProductId) {
        this.addToCartHandler.dataset.productId = embroideryProductId;
      }

      if (embroideryAvailable == 'false' || !embroideryProductId) {
        this.addToCartHandler.classList.add(this.selectors.disabledClass);
      } else {
        this.addToCartHandler.classList.remove(this.selectors.disabledClass);
      }

      if (target.querySelector('img')) {
        this.colorIcon.style.backgroundColor = '';
        this.colorIcon.style.backgroundImage = `url(${target.querySelector('img').src})`;
      } else {
        this.colorIcon.style.backgroundImage = '';
        this.colorIcon.style.backgroundColor = target.querySelector('.inner').style.backgroundColor;
      }

      this.dataset.preorderDate = preorderDate || '';
      this.dataset.backorderDate = backorderDate || '';
      this.dataset.processingTime = processingTime || '';
      this.dataset.productTitle = productTitle || '';
      this.dataset.variantTitle = variantTitle || '';
      this.dataset.finalSale = embroideryFinalSale || '';
      this.updateShipDate();

      if (this.input) {
        this.input.dispatchEvent(new Event('input'));
      } else {
        this.syncAddToCartEnabledState();
      }
    }

    removeCheckboxError(event) {
      const target = event.currentTarget;

      if (target.checked) {
        this.validationMessageConfirmationCheckbox?.classList.remove(this.selectors.activeClass);
      }
    }

    async addToCart(event) {
      event.preventDefault();

      if (this.addToCartHandler?.classList.contains(this.selectors.disabledClass)) {
        return null;
      }

      if (!this.removeCheckboxErrorHandler.checked) {
        this.validationMessageConfirmationCheckbox?.classList.add(this.selectors.activeClass);

        return null;
      }

      const rawInput = this.input?.value ?? '';
      const embroideryText = rawInput.trim();
      if (!embroideryText.length) {
        this.validationMessageTextRequired?.classList.add(this.selectors.activeClass);
        this.validationMessageText?.classList.remove(this.selectors.activeClass);
        this.validationMessageInappropriateLanguage?.classList.remove(this.selectors.activeClass);
        this.openEmbroideryTextAccordion();

        return null;
      }

      if (window.LeoProfanity && window.LeoProfanity.check(rawInput)) {
        this.validationMessageInappropriateLanguage?.classList.add(this.selectors.activeClass);
        this.validationMessageTextRequired?.classList.remove(this.selectors.activeClass);
        this.validationMessageText?.classList.remove(this.selectors.activeClass);
        this.openEmbroideryTextAccordion();

        return null;
      }

      this.validationMessageTextRequired?.classList.remove(this.selectors.activeClass);

      const addToCartTrigger = event.currentTarget;
      const { productId } = addToCartTrigger.dataset;
      const canvasText = this.querySelector(this.selectors.canvasText);
      const transform = getComputedStyle(canvasText).textTransform;
      const shipDate = this.calculateShipDate(
        this.dataset.preorderDate || '',
        this.dataset.backorderDate || '',
        this.dataset.processingTime || ''
      );
      let inputText = canvasText.innerText;

      if (transform === 'uppercase') {
        inputText = inputText.toUpperCase();
      } else if (transform === 'capitalize') {
        inputText = this.enforceSentenceCase(inputText);
      }

      const linePropertyKeys = EMBROIDERY_LINE_PROPERTY;
      const properties = {
        [linePropertyKeys.text]: inputText || '',
        [linePropertyKeys.font]: this.querySelector('[data-font].active-item')?.dataset?.title || '',
        [linePropertyKeys.threadColor]: this.querySelector('[data-thread-color].active-item')?.dataset?.title || '',
        [linePropertyKeys.estimatedShipBy]: shipDate || '',
      };

      const finalSaleNote = this.dataset.finalSaleNote?.trim();
      if (finalSaleNote) {
        properties.Note = finalSaleNote;
      }
      const editLineKey = this.dataset.editCartLineKey;
      const changeCartUrl = getCartChangeJsUrl();
      const addCartUrl = getCartAddJsUrl();

      try {
        if (editLineKey) {
          const newVariantId = +productId;
          const lineItemQuantity = this._editModeQuantity ?? 1;
          const originalVariantId = this._editOriginalVariantId;

          if (originalVariantId != null && newVariantId !== Number(originalVariantId)) {
            const replaceLineAddResponse = await fetch(addCartUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [{
                  id: newVariantId,
                  quantity: lineItemQuantity,
                  properties,
                }]
              })
            });

            if (!replaceLineAddResponse.ok) {
              throw new Error(getEmbroideryThemeString('embroidery_error_save_replacement'));
            }

            await fetch(changeCartUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ id: editLineKey, quantity: 0 })
            });
          } else {
            const changeCartResponse = await fetch(changeCartUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: editLineKey,
                quantity: lineItemQuantity,
                properties,
              })
            });

            if (!changeCartResponse.ok) {
              throw new Error(getEmbroideryThemeString('embroidery_error_update_cart'));
            }
          }

          this.resetEmbroideryCartEdit();

          document.dispatchEvent(
            new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
          );

          if (typeof theme !== 'undefined' && theme.settings && theme.settings.cart_type === 'drawer') {
            document.dispatchEvent(
              new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false })
            );
          }

          this.resetVisualizerFields();
          this.embroideryCloseButton?.click();

          return;
        }

        const addCartResponse = await fetch(addCartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: +productId,
              quantity: 1,
              properties,
            }]
          })
        });

        if (!addCartResponse.ok) {
          throw new Error(getEmbroideryThemeString('embroidery_error_add_to_cart'));
        }

        document.dispatchEvent(
          new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
        );

        if (typeof theme !== 'undefined' && theme.settings && theme.settings.cart_type === 'drawer') {
          document.dispatchEvent(
            new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false })
          );
        } else if (typeof theme !== 'undefined' && theme.strings) {
          theme.showQuickPopup(theme.strings.products_product_added_to_cart, event.currentTarget);
        }

        this.resetVisualizerFields();
        this.embroideryCloseButton?.click();
      } catch (error) {
        console.error(error);
      }
    }

    reinitializeInput = () => {
      this.input?.dispatchEvent(new Event('input'));
    };

    checkAccordions = () => {
      this.accordions.forEach((accordion, index) => {
        if (index === 1) {
          accordion.querySelector('summary').click();
        }
      });
    };

    toggleAccordion(event) {
      event.stopPropagation();

      const summary = event.target.closest('.cc-accordion-item__title');
      if (!summary || !event.currentTarget.contains(summary)) return;

      const clickedItem = summary.closest('.cc-accordion-item');

      const accordionWithOtherOpenItem = [...this.accordions].find((accordion) => {
        const openItem = accordion?.querySelector('.cc-accordion-item.is-open');
        return openItem && openItem !== clickedItem;
      });

      accordionWithOtherOpenItem?.querySelector('summary')?.click();
    };

    applyImageAspectRatio(image) {
      const inner = this.querySelector(this.selectors.imageInner);
      if (!image || !inner) return;
      const updateSizesFromImage = () => {
        const w = image.getBoundingClientRect().width;
        if (!w) return;
        inner.style.setProperty('--embroidery-text-size', `${w * 0.06}px`);
        inner.style.setProperty('--embroidery-text-size-script', `${w * 0.075}px`);
      };

      const set = () => {
        if (image.naturalWidth && image.naturalHeight) {
          inner.style.setProperty('--embroidery-ar', `${image.naturalWidth} / ${image.naturalHeight}`);
        }
        updateSizesFromImage();
      };
      if (image.complete) set();
      else image.addEventListener('load', set, { once: true });

      if (!this._imageSizeObserver) {
        this._imageSizeObserver = new ResizeObserver(updateSizesFromImage);
      }
      this._imageSizeObserver.observe(image);
      updateSizesFromImage();
    }

    connectedCallback() {
      this.checkAccordions();
      this.reinitializeInput();
      this.applyImageAspectRatio(this.querySelector(this.selectors.settingsImage));
      window.addEventListener('pageshow', this.reinitializeInput.bind(this), { once: true });
      this.embroideryCloseButton?.addEventListener('click', this.handleEmbroideryCloseDuringCartEdit);
      window.setTimeout(() => {
        this.applyEmbroideryCartEditFromQuery();
      }, 0);
      this.tooltipHandler?.addEventListener('click', this.toggleTooltip.bind(this));
      this.inputHandler?.addEventListener('input', this.handleInputChange.bind(this));
      this.removeCheckboxErrorHandler?.addEventListener('change', this.removeCheckboxError.bind(this));
      this.addToCartHandler?.addEventListener('click', this.addToCart.bind(this));
      this._boundCloseTooltip = this.closeTooltip.bind(this);
      document.addEventListener('click', this._boundCloseTooltip, true);

      this.dropdownInfoHandlers.forEach(handler => {
        handler.addEventListener('click', this.toggleDropdownInfo.bind(this));
      });

      this.colorHandlers.forEach(handler => {
        handler.addEventListener('click', this.toggleColor.bind(this));
      });

      this.fontHandlers.forEach(handler => {
        handler.addEventListener('click', this.toggleFont.bind(this));
      });

      this.popupInfoHandlers.forEach(handler => {
        handler.addEventListener('click', this.togglePopupInfo.bind(this));
      });

      this.accordionHandlers.forEach(handler => {
        handler.addEventListener('click', this.toggleAccordion.bind(this));
      });
    }

    disconnectedCallback() {
      this.embroideryCloseButton?.removeEventListener('click', this.handleEmbroideryCloseDuringCartEdit);
      this.tooltipHandler?.removeEventListener('click', this.toggleTooltip.bind(this));
      this.inputHandler?.removeEventListener('input', this.handleInputChange.bind(this));
      this.removeCheckboxErrorHandler?.removeEventListener('change', this.removeCheckboxError.bind(this));
      this.addToCartHandler?.removeEventListener('click', this.addToCart.bind(this));
      if (this._boundCloseTooltip) document.removeEventListener('click', this._boundCloseTooltip, true);

      this.dropdownInfoHandlers.forEach(handler => {
        handler.removeEventListener('click', this.toggleDropdownInfo.bind(this));
      });

      this.colorHandlers.forEach(handler => {
        handler.removeEventListener('click', this.toggleColor.bind(this));
      });

      this.fontHandlers.forEach(handler => {
        handler.removeEventListener('click', this.toggleFont.bind(this));
      });

      this.popupInfoHandlers.forEach(handler => {
        handler.removeEventListener('click', this.togglePopupInfo.bind(this));
      });

      this.accordionHandlers.forEach(handler => {
        handler.removeEventListener('click', this.toggleAccordion.bind(this));
      });

    }
  }

  customElements.define(customElements.component, EmbroiderySection);
}

if (!customElements.get(customElements.component_button)) {
  class EmbroideryButton extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        activeClass: 'active-item',
        overflowHiddenClass: 'overflow-hidden',
      }
    }

    togglePopup(event) {
      event.preventDefault();

      if (this.hasAttribute('data-embroidery-close-gallery')) {
        try {
          if (window.theme?.galleryViewerFunctions?.close && document.querySelector('.gallery-viewer')) {
            window.theme.galleryViewerFunctions.close();
          }
        } catch (e) {}
      }

      const mainSection = document.querySelector('.embroidery');
      const body = document.body;

      mainSection.classList.toggle(this.selectors.activeClass);
      body.classList.toggle(this.selectors.overflowHiddenClass);
    }

    connectedCallback() {
      this.addEventListener('click', this.togglePopup.bind(this));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.togglePopup.bind(this));
    }
  }

  customElements.define(customElements.component_button, EmbroideryButton);
}

(() => {
  const CONFIG_SELECTOR = '[data-embroidery-gallery-button]';
  const VIEWER_SELECTOR = '.gallery-viewer';
  const INJECTED_ATTR = 'data-embroidery-gallery-injected';
  const GALLERY_NAV_SELECTOR = '.gallery-viewer__thumb, .gallery-viewer__prev, .gallery-viewer__next';
  let hideByProductMap = null;

  const parseHideByProductMap = (configElement) => {
    if (hideByProductMap) return hideByProductMap;

    const raw = configElement.getAttribute('data-gallery-hide-by-product');
    if (!raw) {
      hideByProductMap = {};
      return hideByProductMap;
    }

    try {
      hideByProductMap = JSON.parse(raw);
    } catch (e) {
      hideByProductMap = {};
    }

    return hideByProductMap;
  };

  const getActiveGalleryImageIndex = (viewer) => {
    const thumbs = viewer.querySelectorAll('.gallery-viewer__thumb');
    let activeIndex = 0;

    thumbs.forEach((thumb, index) => {
      if (thumb.classList.contains('gallery-viewer__thumb--active')) {
        activeIndex = index;
      }
    });

    return activeIndex + 1;
  };

  const updateGalleryButtonVisibility = (viewer, button, configElement) => {
    const productId = String(window.currentProductId || '');
    const hideMap = parseHideByProductMap(configElement);
    const hiddenIndices = (hideMap[productId] || []).map((value) => Number(value));
    const activePosition = getActiveGalleryImageIndex(viewer);
    const shouldHide = hiddenIndices.includes(activePosition);

    button.classList.toggle('embroidery-button-pdp--gallery-hidden', shouldHide);
  };

  const buildButton = (label) => {
    const button = document.createElement('embroidery-button');
    button.className = 'button button--large embroidery-button-pdp embroidery-button-pdp--gallery';
    button.setAttribute('type', 'button');
    button.setAttribute('data-embroidery-button', '');
    button.setAttribute('data-embroidery-close-gallery', '');
    button.textContent = label || 'personalize';
    return button;
  };

  const tryInject = () => {
    const configElement = document.querySelector(CONFIG_SELECTOR);
    if (!configElement) return;

    const viewer = document.querySelector(VIEWER_SELECTOR);
    if (!viewer) return;
    if (viewer.hasAttribute(INJECTED_ATTR)) return;

    const label = configElement.getAttribute('data-label') || '';
    const button = buildButton(label);
    viewer.appendChild(button);
    viewer.setAttribute(INJECTED_ATTR, 'true');
    updateGalleryButtonVisibility(viewer, button, configElement);
  };

  const onGalleryNavigate = (event) => {
    if (!event.target.closest(GALLERY_NAV_SELECTOR)) return;

    const configElement = document.querySelector(CONFIG_SELECTOR);
    const viewer = document.querySelector(VIEWER_SELECTOR);
    const button = viewer?.querySelector('.embroidery-button-pdp--gallery');

    if (!configElement || !viewer || !button) return;

    requestAnimationFrame(() => {
      updateGalleryButtonVisibility(viewer, button, configElement);
    });
  };

  const observer = new MutationObserver(() => {
    tryInject();
  });

  const start = () => {
    tryInject();
    document.addEventListener('click', onGalleryNavigate, true);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();